import { Fragment, useCallback, useContext, useEffect, useState } from 'react';
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';
import './MapComponent.scss';
import "leaflet/dist/leaflet.css";
import L from 'leaflet';
import MyContext from '../../../02Contexts/Mycontext';
import { BiWorld } from 'react-icons/bi';
import placeIcon from './icon/places.png';
import userIcon from './icon/location.png';

// import ReactLeafletGoogleLayer from 'react-leaflet-google-layer';
// import GoogleLayer from './GoogleLayer'

const genericIcon = L.icon({
    iconUrl: placeIcon,
    iconRetinaUrl: placeIcon,
    iconSize: [48, 48],
});



const userIconL = L.icon({
    iconUrl: userIcon,
    iconRetinaUrl: userIcon,
    iconSize: [36, 36],
});

L.Marker.prototype.options.icon = genericIcon;

export default function MapComponent() {

    const { location, setLocation, list, setDetails, map, setMap } = useContext(MyContext)

    const [points, setPoints] = useState(<Fragment></Fragment>)

    const renderPoints = useCallback(() => {
        setPoints(list.map(item => {
            return (
                <Marker position={item.location} icon={genericIcon} key={item.name} eventHandlers={{
                    click: (e) => {
                        setDetails(item)
                        map.flyTo(item.location, 17, { duration: 0.4 });
                    }
                }}>
                    <Popup className='map_popup'>
                        <p><strong>Nome:</strong> {item.name}</p>
                        <p><strong>Bairro:</strong> {item.city}</p>
                        <p><strong>Endereço:</strong> {item.adress}</p>
                        <p><strong>Funcionamento:</strong> {item.fulltime ? '24 horas' : item.time}</p>
                        <p><strong>Telefone:</strong> {item.phone}</p>
                    </Popup>
                </Marker>
            )
        })
        )
    }, [list, map, setDetails])

    useEffect(() => {
        renderPoints()
    }, [location, setLocation, list, renderPoints])


    return (
        <Fragment>
            {(location) ?
                <Fragment>
                    <MapContainer center={location} zoom={14} whenCreated={map => {
                        setMap(map)
                        // L.marker(location, { icon: userIconL }).addTo(map);
                    }}
                        scrollWheelZoom={true} id='map_component'>
                        {/* <Circle center={location}
                            pathOptions={{ color: 'rgba(15,45,82,0.8)', fillColor: 'transparent' }} radius={radius} /> */}

                        {/* <ReactLeafletGoogleLayer googleMapsLoaderConf={{ KEY: 'AIzaSyA1FjCoK5kjw9cFcSUnUMA8cmwzx290ijE' }} type={'roadmap'} /> */}
                        {/* <GoogleLayer type='roadmap' googlekey='AIzaSyA1FjCoK5kjw9cFcSUnUMA8cmwzx290ijE'/> */}
                        < TileLayer
                            // attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                            // url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, &copy; <a href="https://carto.com/attribution">CARTO</a>'
                            url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png"
                        />
                        {points}
                        <Marker position={location} icon={userIconL} />
                    </MapContainer >
                </Fragment>
                :
                <div id='map_component'>
                    <BiWorld id='world_icon' size='15rem' className='my-3' />
                    <h3>Aguardando localização</h3>
                </div>
            }
        </Fragment>
    )
}

